import { getAggregatedFilterGroups } from 'framework-listing-lib/earlyRequester/filters';
import { ALL_FORMS_VIEW_FILTERS, ALL_FORMS_VIEW_NAME, CRM_SEARCH_REQUEST_DEFAULT_OPTIONS, DEFAULT_FILTERS, DEFAULT_SORTS, FOLDER_URL_REG, MANAGE_URL_REG, NON_HUBSPOT_FORMS_VIEW_NAME, NON_HUBSPOT_FORMS_VIEW_FILTERS, PUBLISHED_FORMS_VIEW_FILTERS, PUBLISHED_FORMS_VIEW_NAME, FORMS_WITH_SUBMISSIONS_VIEW_FILTERS, FORMS_WITH_SUBMISSIONS_VIEW_NAME, PUBLISHED_FORMS_VIEW_SORTS, ALL_FORMS_VIEW_SORTS, FORMS_WITH_SUBMISSIONS_VIEW_SORTS, NON_HUBSPOT_FORMS_VIEW_SORTS, HIDDEN_FILTER } from 'FormsUI/earlyRequest/constants';
export const getQueryParams = () => {
  const searchParams = new URLSearchParams(window.location.search);
  return Object.fromEntries(searchParams.entries());
};
export const ISSUE_DAYS = 90;
export function getViewFromPathname(pathname) {
  const match = pathname.match(MANAGE_URL_REG);
  const view = (match || [])[1];
  return view;
}
export function getQueryFromSearch(search) {
  return new URLSearchParams(search).get('search');
}
export function getWindowPathname() {
  return window.location.pathname;
}
export function getWindowSearch() {
  return window.location.search;
}
export function isFolderPathname(pathname) {
  return FOLDER_URL_REG.test(pathname);
}
export function getSearchOptions({
  view,
  query
}) {
  if (typeof view === 'object') {
    const viewFilterGroups = JSON.parse(view.filterGroups);
    const viewQuickFilters = JSON.parse(view.quickFilters);
    const filterGroups = getAggregatedFilterGroups({
      filterGroups: viewFilterGroups,
      quickFilters: viewQuickFilters,
      includeHiddenFilter: true,
      hiddenFilter: HIDDEN_FILTER,
      deletedObjects: []
    });
    return Object.assign({}, CRM_SEARCH_REQUEST_DEFAULT_OPTIONS, {
      filterGroups,
      query: query || ''
    });
  }
  let filterGroup = DEFAULT_FILTERS;
  let sorts = DEFAULT_SORTS;
  if (view === ALL_FORMS_VIEW_NAME) {
    filterGroup = ALL_FORMS_VIEW_FILTERS;
    sorts = ALL_FORMS_VIEW_SORTS;
  } else if (view === PUBLISHED_FORMS_VIEW_NAME) {
    filterGroup = PUBLISHED_FORMS_VIEW_FILTERS;
    sorts = PUBLISHED_FORMS_VIEW_SORTS;
  } else if (view === FORMS_WITH_SUBMISSIONS_VIEW_NAME) {
    filterGroup = FORMS_WITH_SUBMISSIONS_VIEW_FILTERS;
    sorts = FORMS_WITH_SUBMISSIONS_VIEW_SORTS;
  } else if (view === NON_HUBSPOT_FORMS_VIEW_NAME) {
    filterGroup = NON_HUBSPOT_FORMS_VIEW_FILTERS;
    sorts = NON_HUBSPOT_FORMS_VIEW_SORTS;
  }
  return {
    filterGroups: [{
      filters: filterGroup
    }],
    query: query || '',
    sorts,
    associationSpecs: [],
    hasAssociationSpecs: false
  };
}